import { jsx as _jsx } from "react/jsx-runtime";
import { useHistory } from 'react-router';
import { useOverlayContext } from 'seagull';
import { routes } from '~/constants';
import { useLocaleKeys } from '~/i18n';
import IntegrationCard from '~/integrations/AvailableAppsPage/IntegrationCard/IntegrationCard';
import { getPMDetails } from '~/integrations/PracticeManagement/pm.utils';
import { integrationModel } from '~/models';
import { PracticeManagement } from '~/types/api.model';
import ConnectKeeperModal from '../ConnectKeeperModal/ConnectKeeperModal';
import DoubleLogo from './double-logo.png';
export default function KeeperCard(param) {
    let { integration } = param;
    const { t: keeperTexts } = useLocaleKeys('integrations.availableApps.keeper');
    const { t: sharedTexts } = useLocaleKeys('integrations.availableApps.shared');
    const overlayContext = useOverlayContext();
    const history = useHistory();
    const keeperDetails = getPMDetails(PracticeManagement.Keeper);
    const openIntegrateWithKeeperModal = ()=>{
        overlayContext.showModal({
            biName: 'connect_keeper_modal',
            closeOnEscapeKey: true,
            closeOnClickOutside: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(ConnectKeeperModal, {
                    dismissModal: dismissModal
                });
            }
        });
    };
    const handleClick = ()=>{
        if (integrationModel.isLinked(integration)) {
            history.push(routes.keeperSetup);
        } else {
            openIntegrateWithKeeperModal();
        }
    };
    return /*#__PURE__*/ _jsx(IntegrationCard, {
        testId: "keeper-card",
        icon: /*#__PURE__*/ _jsx(IntegrationCard.LogoImg, {
            padding: "6px 0",
            alt: "".concat(keeperDetails.name, " logo"),
            src: DoubleLogo
        }),
        title: keeperDetails.name,
        subTitle: keeperTexts.subTitle(),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            bi: {
                name: 'connect_keeper'
            },
            onClick: handleClick,
            testId: "keeper-card-connect",
            children: integrationModel.isLinked(integration) ? sharedTexts.manageConnection() : sharedTexts.connectButton()
        })
    });
}
